import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";
import { KreFormAntService } from "../tools/service";

@Component({
  selector: "krefield-image",
  template: `
    <ng-container *ngIf="formStatus !== 0; else other">
      <div class="control-design">
        <input nz-input disabled />
      </div>
    </ng-container>
    <ng-template #other>
      <nz-avatar
        nzIcon="user"
        nzSrc="//zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnKreCYX.png"
      ></nz-avatar>
      <!-- <div class="tips">
        <i
          class="icon-bangzhu"
          [nzTooltipTitle]="tips"
          nzTooltipPlacement="top"
          nz-tooltip
          *ngIf="tips != ''"
        ></i>
      </div> -->
    </ng-template>
  `,
})
export class KreFormFieldImage extends FieldType {}
